import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { FcchartbarComponent } from './fcchartbar.component';
import { FcchartpieComponent } from './fcchartpie.component';
import { FcchartlineComponent } from './fcchartline.component';
import { NgxChartsModule } from '@swimlane/ngx-charts';
import { FcshareModule } from '../fcshare.modal';
@NgModule({
  imports: [
    FcshareModule,
    NgxChartsModule
  ],
  exports: [
    FcchartbarComponent,
    FcchartpieComponent,
    FcchartlineComponent
  ],
  declarations: [
    FcchartbarComponent,
    FcchartpieComponent,
    FcchartlineComponent
  ],
  providers: [
  ],
  schemas: [ CUSTOM_ELEMENTS_SCHEMA ]
})
export class FcchartModule {}
